<script setup>
const route = useRoute()
if (route.path.split('/')[1] !== 'ranking' || !areaToPrefTable.some(({ key }) => key === route.params.area)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
const areaName = getJpAreaName(route.params.area)
useCustomMeta('ranking', areaName)
const breadCrumbList = [{ text: 'ゴルフ場の天気', link: '../../' }, { text: 'ランキング' }]
</script>

<template>
  <div>
    <NuxtLayout
      name="ranking"
      :bread-crumb-list="breadCrumbList"
    >
      <GolfRecommendAll :area="route.params.area" />
    </NuxtLayout>
  </div>
</template>
